import { medQuestionnaire } from './mq';
import { needAnalysis } from './na';
import { adfsAuth } from './adfs';
import { contentFragment } from './cfm';
import { keepAlive } from './idle';
import { tms } from './tms';
import { policySearch } from './policy-search';
import { policyInfo } from './policy-info';
import { policyDelivery } from './policy-delivery';
import { policyHistory } from './policy-history';
import { policyNotes } from './policy-notes';
import { travellerSelection } from './traveller-selection';
import { travellersDetails } from './travellers-details';
import { travellersPlan } from './travellers-plan';
import { quote } from './quote';
import { recommendation } from './recommendation';
import { travellerPayment } from './traveller-payments';
import { policyCreate } from './policy-create';
import { remerchCreate } from './remerchandise';
import { policyPdf } from './policy-getpdf';
import { userInfo } from './user-info';
import user from './user-info/userSlice';
import { userListing } from './user-listing';
import { userProfile } from './user-profile';
import { quoteForm } from './quote-form';
import { config } from './config';
import { travelLocations } from './destination';
import { organization } from './organization';
import { policyUpdate } from './policy-update';
import { cancelPolicy } from './policy-cancel';
import { licenseInfo } from './license';
import license from './license/licenseSlice';
import { reportOrganization } from './report';
import { agencyOrganization } from './agency';
import agent from './user-listing/agentSlice';
import rates from './reprice/ratesSlice';
import advisor from './advisor/advisorSlice';
import agency from './agency/agencySlice';
import downloadRates from './download-rates/downloadRatesSlice';
import allocations from './allocations/allocationsSlice';
import destinationMultiplier from './destination-multiplier/destinationMultiplierSlice';
import { advisorReportOrganization } from './advisorReports';
import { advisorApi } from './advisor/advisorApi';

export const reducers = {
  config,
  medQuestionnaire,
  needAnalysis,
  advisor,
  [advisorApi.reducerPath]: advisorApi.reducer,
  keepAlive,
  adfsAuth,
  contentFragment,
  policySearch,
  tms,
  policyInfo,
  policyDelivery,
  policyHistory,
  policyNotes,
  travellerSelection,
  travellersDetails,
  travellersPlan,
  quote,
  recommendation,
  travellerPayment,
  policyCreate,
  remerchCreate,
  policyPdf,
  user,
  userInfo,
  userListing,
  userProfile,
  quoteForm,
  travelLocations,
  organization,
  policyUpdate,
  cancelPolicy,
  license,
  licenseInfo,
  reportOrganization,
  agencyOrganization,
  agent,
  rates,
  agency,
  downloadRates,
  allocations,
  destinationMultiplier,
  advisorReportOrganization
};

export default reducers;
